import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useStore, extractErrorMessage } from "../../../helpers";
import { TARS_CANVAS_DELETE_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./tars-notebook-last-touched";

export interface DeleteCanvasPayload {
  canvas_id: number;
  notebook_id?: number;
  type?: string;
  name?: string;
}

const DELETE_SUCCESS_BY_TYPE: Record<string, string> = {
  thinkSpace: "ThinkSpace deleted successfully",
  analytics: "Analytics deleted successfully",
};

function deleteCanvasSuccessMessage(vars: DeleteCanvasPayload): string {
  const byType = vars.type ? DELETE_SUCCESS_BY_TYPE[vars.type] : undefined;
  if (byType) return byType;
  const n = vars.name?.trim();
  if (n) return `"${n}" deleted`;
  return "Canvas deleted successfully";
}

export const useDeleteCanvas = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: DeleteCanvasPayload): Promise<void> => {
      await rootStore.apiRequestHandler(
        TARS_CANVAS_DELETE_PATH,
        { canvas_id: payload.canvas_id },
        "Failed to delete canvas"
      );
    },
    onSuccess: (_data, variables) => {
      toast.success(deleteCanvasSuccessMessage(variables));
      queryClient.invalidateQueries({ queryKey: ["tars", "canvas", "list"] });
      markTarsNotebookActivity(queryClient, variables.notebook_id);
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to delete canvas"));
    },
  });
};
